import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { POSTSystemCatalogItem } from '../queries'

// Assuming these are the types from your POSTSystemCatalogCategory function
// Adjust these types according to your actual implementation
type CategoryData = unknown // The return type of your mutation
type CategoryError = unknown // The error type
type CategoryVariables = unknown // The variables type

function usePostSystemCatalogItem(
  options?: Omit<
    UseMutationOptions<CategoryData, CategoryError, CategoryVariables>,
    'mutationFn'
  >
) {
  return useMutation({
    mutationFn: POSTSystemCatalogItem,
    ...options,
  })
}

export default usePostSystemCatalogItem
